const shabbatTutorial = {
  module: 'shabbat',
  moduleName: 'Sabbath Mode',
  steps: [
    { target: '.page-title', position: 'bottom', title: 'Sabbath Mode', description: 'Automated door scheduling for Shabbat and Jewish holidays.' },
    { target: '.toggle-switch', position: 'bottom', title: 'Enable/Disable', description: 'Toggle Sabbath mode automation on or off.' },
    { target: '.page-header-actions', position: 'bottom', title: 'Test & Save', description: 'Test the workflow before saving, then save your configuration.' },
  ],
};
export default shabbatTutorial;
